import { useEffect, useState } from "react";
import { db } from "@healthdesk/shared-services";
import {
  MAP_CAROUSEL_COLLECTION,
  MAP_CAROUSEL_STATS_DOC_ID,
} from "../services/mapCarousel";

/**
 * Live `publicConfig/mapCarouselStats` for CareMap carousel ordering (anonymous + signed-in).
 * Falls back to Firestore slide order when `statsReady` is false (loading or snapshot error).
 */
const usePublicMapCarouselStats = () => {
  const [statsBySlideId, setStatsBySlideId] = useState({});
  const [hydrated, setHydrated] = useState(false);
  const [statsError, setStatsError] = useState(null);

  useEffect(() => {
    const ref = db
      .collection(MAP_CAROUSEL_COLLECTION)
      .doc(MAP_CAROUSEL_STATS_DOC_ID);
    const unsub = ref.onSnapshot(
      (snap) => {
        setStatsError(null);
        setHydrated(true);
        if (!snap.exists) {
          setStatsBySlideId({});
          return;
        }
        const raw = snap.data()?.bySlideId;
        setStatsBySlideId(raw && typeof raw === "object" ? raw : {});
      },
      (err) => {
        console.warn("usePublicMapCarouselStats: snapshot failed", err);
        setStatsError(err);
        setHydrated(true);
        setStatsBySlideId({});
      }
    );
    return () => unsub();
  }, []);

  const statsReady = hydrated && !statsError;

  return { statsBySlideId, statsReady, statsError };
};

export default usePublicMapCarouselStats;
